module.exports = __webpack_public_path__ + "/login_ui/img/sr-5de7e873cd4c92b5b3ae9c66f6b98f08.svg";